import React, { useContext, useMemo } from 'react';
import { connect } from 'react-redux';
import { changeConst, changePred, changeFun } from '../actions';
import LogicContext from '../components/LogicContext';

const DisplayLanguage = ({
  language,
  changeConst,
  changePred,
  changeFun
}) => {
  const context = useContext(LogicContext);
  useMemo(() => context?.constantsExpr && changeConst(context.constantsExpr, true), [context?.constantsExpr]);
  useMemo(() => context?.functionsExpr && changeFun(context.functionsExpr, true), [context?.functionsExpr]);
  useMemo(() => context?.predicatesExpr && changePred(context.predicatesExpr, true), [context?.predicatesExpr]);
  return /*#__PURE__*/React.createElement("div", {
    className: "mt-2"
  }, /*#__PURE__*/React.createElement("h2", null, "Language"), /*#__PURE__*/React.createElement("div", {
    className: "pl-3"
  }, /*#__PURE__*/React.createElement("p", null, /*#__PURE__*/React.createElement("span", null, "\uD835\uDCD2", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"), " ", language.consts.symbols.join(', '), " } ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "\uD835\uDCDF", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"), " ", language.preds.symbols.map(tuple => tuple.name + '/' + tuple.arity).join(', '), " } ", /*#__PURE__*/React.createElement("br", null), /*#__PURE__*/React.createElement("span", null, "\uD835\uDCD5", /*#__PURE__*/React.createElement("sub", null, "\uD835\uDCDB"), " = {"), " ", language.funs.symbols.map(tuple => tuple.name + '/' + tuple.arity).join(', '), " }")));
};

const mapStateToProps = state => ({
  language: state.present.language
});

const mapDispatchToProps = {
  changeConst,
  changePred,
  changeFun
};
const DisplayActualLanguage = connect(mapStateToProps, mapDispatchToProps)(DisplayLanguage);
export default DisplayActualLanguage;